import { NodeViewWrapper, NodeViewProps } from '@tiptap/react'
import cn from 'classnames'
import { FC, useCallback } from 'react'

import styles from './VideoView.module.scss'

import Button from '~elements/Button'
import TrashIcon from '~icons/trash.svg'

const VideoView: FC<React.PropsWithChildren<NodeViewProps>> = ({ editor, node, selected, deleteNode }) => {
  const handleVideoClick = useCallback(
    (ev: any) => {
      if (editor.isEditable) {
        ev.preventDefault() // prevent play/pause on click
      }
    },
    [editor]
  )

  const { filename, ...restAttrs } = node.attrs

  return (
    <NodeViewWrapper className={cn(styles.root, { [styles.selected]: selected })}>
      <div className={styles.inner} contentEditable="false" data-drag-handle>
        <div className={styles.controls}>
          {editor.isEditable && <Button icon={<TrashIcon />} size="m" variant="attention" onClick={deleteNode} />}
        </div>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video controls onClick={handleVideoClick} {...restAttrs} />
      </div>
    </NodeViewWrapper>
  )
}

export default VideoView
